module.exports = __webpack_public_path__ + "static/media/default-account-logo.a8f7d014.svg";